import { observer } from "mobx-react-lite";
import React from "react";
import { OverlayWrapper } from "../../components/OverlayRouter";
import { UseFormsetType, useFormset } from "./FormsetFormDrawer";

export const Formset = observer(
  ({
    formsetValues,
    Component,
    onEdit,
    addButtonText,
    onAdd,
    onSave,
    ComponentForm,
    currentFormIndex,
    formDefaultValue = {},
    additionalFormProps = {},
    onRemove,
    formHeaderText,
    isLoading,
    saveButtontext,
    removeAddButton,
    validateForm,
    leaveText,
    FormsetHeader = React.Fragment,
    onLeave,
    headerProps = {},
    asModal = true,
    path = "/detail",
  }: {
    formsetValues?: any;
    Component?: any;
    onEdit?: any;
    addButtonText?: any;
    onAdd?: any;
    onSave?: (values: any) => Promise<any>;
    validateForm: UseFormsetType["validateForm"];
    ComponentForm?: any;
    currentFormIndex?: any;
    isLoading?: boolean;
    formDefaultValue?: any;
    additionalFormProps?: any;
    onRemove?: any;
    formHeaderText?: any;
    saveButtontext: string;
    leaveText?: string;
    removeAddButton?: boolean;
    FormsetHeader?: any;
    onLeave?: () => any;
    asModal?: boolean;
    headerProps?: any;
    path?: string | null;
  }) => {
    const { formSummary, drawerForm } = useFormset({
      formsetValues,
      Component,
      onEdit,
      addButtonText,
      onAdd,
      onSave,
      ComponentForm,
      currentFormIndex,
      formDefaultValue,
      additionalFormProps,
      onRemove,
      formHeaderText,
      isLoading,
      saveButtontext,
      removeAddButton,
      validateForm,
      leaveText,
      onLeave,
      isModal: asModal,
      isMobile: !asModal,
      path,
    });
    return (
      <FormsetContainer
        drawerForm={drawerForm}
        reRender={additionalFormProps.length}
        path={path}
      >
        <FormsetHeader {...headerProps}>{formSummary}</FormsetHeader>
      </FormsetContainer>
    );
  },
);

type FormsetContainerProps = {
  drawerForm: any;
  reRender?: any;
  children: React.ReactNode;
  path?: string | null;
  isOpen?: boolean;
};
const FormsetContainer = ({
  children,
  reRender,
  drawerForm,
  path,
}: FormsetContainerProps) => {
  if (path) {
    return (
      <>
        <OverlayWrapper key={reRender} exact={true} path="/">
          {children}
        </OverlayWrapper>
        <OverlayWrapper key={reRender} exact={false} path={path}>
          {drawerForm}
        </OverlayWrapper>
      </>
    );
  }
  return (
    <>
      {children}
      {drawerForm}
    </>
  );
};
